<template>
  <v-form ref="formActivity" lazy-validation>
    <v-col cols="12" class="pt-0">
      <v-row no-gutters>
        <v-col cols="10">
          <v-radio-group
            v-model="comment.type"
            row
            :style="{ height: '40px' }"
            class="justify-center items-center align-center mt-0 pt-0"
            hide-details
          >
            <template v-for="(type, i) in commentTypesFiltered">
              <v-radio
                v-if="type.allow_user"
                :key="i"
                :color="type.color"
                :value="type.id"
                selected
                :on-icon="type.icon"
                :off-icon="type.icon"
                class="px-2"
              />
            </template>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-col>

    <v-col v-if="comment.type === $activityTypes.WHATSAPP">
      <v-row v-if="getTicket.wa_response">
        <v-col cols="12" class="py-0 d-flex justify-end"
          ><v-btn :loading="loadingMarkAsRead" color="primary" x-small outlined dark @click="markAsRead">
            Marcar como leído
          </v-btn></v-col
        >
      </v-row>
      <v-row v-if="!getTicket.is_bot_stopped">
        <v-col cols="12" class="text-center">
          <p class="mb-2">Bot de Whatsapp activo en esta conversación</p>
          <v-btn
            :loading="loadingHandleWhatsappBotStatus"
            color="primary"
            rounded
            small
            @click="onHandleWhatsappBotStatus"
          >
            Desactivar bot
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="getTicket.is_bot_stopped && getBusiness.use_ia">
        <v-col cols="12" class="text-center">
          <p class="mb-2">Bot de Whatsapp detenido en esta conversación</p>
          <v-btn
            :loading="loadingHandleWhatsappBotStatus"
            color="primary"
            rounded
            small
            @click="onHandleWhatsappBotStatus"
          >
            Activar bot
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="getTicket.is_bot_stopped">
        <v-col cols="12">
          <v-select
            v-model="whatsappApp"
            :rules="[$rules.REQUIRED]"
            :items="getWhatsAppApps"
            :item-text="(item) => `${item.verified_name} (${item.display_phone_number})`"
            item-value="id"
            label="Responder desde"
            return-object
          />
        </v-col>

        <v-col cols="12" class="py-0 d-flex">
          <div class="my-auto">
            <v-checkbox
              v-model="useMessageTemplate"
              label="Enviar plantilla de mensaje"
              color="accent"
              class="my-0 py-0"
              :style="{ height: '24px' }"
              hide-details
              @change="onCheckWhatsappMessageTemplate($event)"
            />
          </div>

          <v-spacer />

          <v-speed-dial
            v-if="whatsappApp && whatsappApp.platform !== 'wweb'"
            v-model="fab"
            :top="true"
            :right="true"
            direction="bottom"
            :open-on-hover="true"
            transition="slide-y-transition"
            class="speed-dial-custom"
          >
            <template #activator>
              <v-btn v-model="fab" icon>
                <v-icon v-if="fab" small> fa fa-times </v-icon>
                <v-icon v-else small> fas fa-paperclip </v-icon>
              </v-btn>
            </template>
            <v-btn
              v-if="['image', 'document', 'upload'].includes(whatsappMessageType)"
              fab
              dark
              small
              color="accent"
              @click="onChangeWhatsAppMessageType('text')"
            >
              <v-icon small>fas fa-align-center</v-icon>
            </v-btn>
            <v-btn fab dark small color="purple" @click="onChangeWhatsAppMessageType('image')">
              <v-icon small>fas fa-image</v-icon>
            </v-btn>
            <v-btn fab dark small color="blue" @click="onChangeWhatsAppMessageType('video')">
              <v-icon small>fas fa-video</v-icon>
            </v-btn>
            <v-btn fab dark small color="indigo" @click="onChangeWhatsAppMessageType('document')">
              <v-icon small>fas fa-file</v-icon>
            </v-btn>
            <v-btn fab dark small color="orange" @click="onChangeWhatsAppMessageType('upload')">
              <v-icon small>fas fa-upload</v-icon>
            </v-btn>
          </v-speed-dial>
        </v-col>

        <template v-if="useMessageTemplate">
          <v-col cols="12" class="d-flex">
            <SelectMessageTemplates :message-template-id.sync="whatsappMessageTemplate" :is-required="false" />

            <v-btn v-if="whatsappMessageTemplate" text icon class="ml-2 my-auto" @click="onOpenModalPreview">
              <v-icon dark small> fas fa-eye </v-icon>
            </v-btn>
          </v-col>

          <v-col v-if="messageTemplateSelected && messageTemplateSelected.body_params?.length" cols="12">
            <v-row>
              <v-col cols="12" class="py-0">
                <h5>Variables de plantilla</h5>
                <p class="text-caption mt-2 mb-0">
                  Complete los siguientes campos para enviar la plantilla de mensaje correctamente.
                </p>
              </v-col>
              <v-col v-for="param in messageTemplateSelected.body_params" :key="param.name" cols="12">
                <v-text-field v-model="param.value" :label="param.name" :rules="[$rules.REQUIRED]" class="mb-4" />
              </v-col>
            </v-row>
          </v-col>
        </template>

        <v-col v-if="['image', 'document', 'video'].includes(whatsappMessageType)" class="d-flex">
          <v-select
            v-model="whatsappMessageMedia"
            :items="filesFiltered"
            :rules="[$rules.REQUIRED]"
            :label="
              whatsappMessageType === 'image' ? 'Imagen' : whatsappMessageType === 'video' ? 'Video' : 'Documento'
            "
            item-value="id"
            item-text="name"
          />
          <template v-if="whatsappMessageMedia">
            <v-tooltip v-if="whatsappMessageType === 'image'" bottom>
              <template #activator="{ on }">
                <v-btn text icon class="ml-2 my-auto" @click="onOpenModalImageViewer" v-on="on">
                  <v-icon dark small> fas fa-image </v-icon>
                </v-btn>
              </template>
              <span>Ver imagen</span>
            </v-tooltip>

            <v-tooltip v-if="whatsappMessageType === 'document'" bottom>
              <template #activator="{ on }">
                <v-btn text icon class="ml-2 my-auto" @click="onOpenModalPreview" v-on="on">
                  <v-icon dark small> fas fa-file-download </v-icon>
                </v-btn>
              </template>
              <span>Descargar documento</span>
            </v-tooltip>
          </template>
        </v-col>

        <v-col v-if="whatsappMessageType === 'upload'">
          <v-file-input
            v-model="fileContent"
            label="Archivo"
            accept="text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :rules="[
              $rules.REQUIRED,
              fileType
                ? (v) =>
                    (fileType && v && v.size < fileType.maxSize) ||
                    `El archivo debe ser menor a ${fileType.maxSize / 1000000}MB`
                : true,
              (v) => {
                if (v && v.type.includes('image/')) {
                  return 'Tipo de archivo no válido';
                }
                return true;
              },
            ]"
            placeholder="Seleccione archivo a enviar"
            clear-icon="fa-times"
            truncate-length="50"
            prepend-icon=""
            show-size
          ></v-file-input>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      v-if="
        !useMessageTemplate &&
        comment.type !== $activityTypes.EVENT &&
        (comment.type !== $activityTypes.WHATSAPP ||
          (comment.type === $activityTypes.WHATSAPP && getTicket.is_bot_stopped))
      "
    >
      <v-textarea
        v-model="comment.text"
        :rules="whatsappMessageType === 'text' ? [$rules.REQUIRED] : []"
        :label="whatsappMessageType === 'text' ? 'Mensaje de texto' : 'Escribe un comentario...'"
        flat
        auto-grow
        rows="1"
        class="expand"
      />
    </v-col>

    <v-col v-if="responseErrorMessage" cols="12">
      <v-alert text type="error" class="mb-0">
        {{ responseErrorMessage }}
      </v-alert>
    </v-col>

    <v-btn
      v-if="
        (comment.type !== $activityTypes.WHATSAPP && comment.type !== $activityTypes.EVENT) ||
        (comment.type === $activityTypes.WHATSAPP && getTicket.is_bot_stopped)
      "
      :color="getCommentTypes[comment.type].color"
      block
      outlined
      class="mt-2"
      depressed
      :loading="loading"
      @click.stop="onComment"
    >
      <v-icon left dark>
        {{ getCommentTypes[comment.type].icon }}
      </v-icon>
      Comentar
    </v-btn>

    <ModalPreview
      v-if="dialogPreview"
      :dialog.sync="dialogPreview"
      :message-template-selected="messageTemplateSelected"
    />
    <ModalImageViewer v-if="dialogImageViewer" :dialog.sync="dialogImageViewer" :url="messageMediaSelected" />
    <NewEvent
      v-if="dialogNewEvent"
      :dialog.sync="dialogNewEvent"
      :ticket-id="ticketId"
      @update:dialog="onNewEventClose"
    />
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    ModalPreview: () => import("@/views/channels/whatsapp/message-templates/modals/Preview"),
    ModalImageViewer: () => import("@/components/modals/ImageViewer"),
    SelectMessageTemplates: () => import("@/components/inputs/SelectMessageTemplates"),
    NewEvent: () => import("@/views/tickets/modals/NewEvent"),
  },
  props: {
    ticketId: { type: String, default: "" },
    colFixed: { type: Number, default: 0 },
  },
  data() {
    return {
      fab: false,
      today: this.$moment().format("YYYY-MM-DD"),
      comment: { type: this.$activityTypes.WHATSAPP },
      whatsappApp: null,
      whatsappMessageType: "text",
      whatsappMessageMedia: null,
      whatsappMessageTemplate: null,
      useMessageTemplate: false,
      loading: false,
      responseErrorMessage: null,
      dialogPreview: false,
      messageTemplateSelected: null,
      dialogImageViewer: false,
      messageMediaSelected: null,
      fileContent: null,
      fileType: null,
      dialogNewEvent: false,
      loadingHandleWhatsappBotStatus: false,
      loadingMarkAsRead: false,
    };
  },
  computed: {
    ...mapGetters([
      "getBusiness",
      "getShowTicketDetailDrawerSection",
      "getCommentTypes",
      "getTicket",
      "getWhatsAppApps",
      "getWhatsAppMessageTemplates",
      "getWhatsAppApprovedMessageTemplates",
      "getFiles",
      "getDefaultFileTypes",
    ]),
    commentTypesFiltered() {
      let commentTypes = { ...this.getCommentTypes };

      delete commentTypes[this.$activityTypes.CALL];
      delete commentTypes[this.$activityTypes.COMMENT];

      if (!this.getTicket.phone) delete commentTypes[this.$activityTypes.WHATSAPP];

      return commentTypes;
    },
    filesFiltered() {
      return [...(this.getFiles || [])].filter((file) => file.type === this.whatsappMessageType);
    },
  },
  watch: {
    "comment.type"(value, oldValue) {
      if (value !== oldValue) {
        this.resetComment();
        if (value === this.$activityTypes.EVENT) {
          this.dialogNewEvent = true;
        }
      }
    },
    fileContent(value) {
      this.fileType = value ? this.getDefaultFileTypes.find((type) => type.accept.includes(value.type)) : null;
    },
    useMessageTemplate(value) {
      if (value)
        this.loadWhatsAppMessageTemplates().catch((error) => {
          console.error("comment/loadWhatsAppMessageTemplates: ", error);
        });
    },
    whatsappMessageType(value) {
      if (["image", "video", "document"].includes(value))
        this.loadFiles().catch((error) => {
          console.error("comment/loadFiles: ", error);
        });
    },
    whatsappMessageTemplate(value) {
      let messageTemplate = this.getWhatsAppApprovedMessageTemplates.find((template) => template.id === value);

      if (messageTemplate && messageTemplate.body_params) {
        messageTemplate.body_params = messageTemplate.body_params.map((param) => ({
          name: param.name,
          value: param.ticket_field_id ? this.getTicket[param.ticket_field_id] || "" : param.example || "",
        }));
      }

      this.messageTemplateSelected = { ...messageTemplate };
    },
  },
  created() {
    if (this.getShowTicketDetailDrawerSection) {
      let commentType = this.getShowTicketDetailDrawerSection.split("#")[1];
      if (commentType === "whatsapp") this.comment = { type: this.$activityTypes.WHATSAPP };
    }

    this.init().catch((error) => {
      console.error("comment/init: ", error);
    });
  },
  methods: {
    ...mapActions([
      "addActivity",
      "getAllWhatsAppApps",
      "getAllWhatsAppMessageTemplates",
      "addTicketComment",
      "addTicketCommentMedia",
      "getAllFiles",
      "setTicketBotStatus",
      "setTicketReadWaResponse",
    ]),
    async init() {
      if (!this.getWhatsAppApps) await this.getAllWhatsAppApps();

      if (this.getTicket?.wa_phone_number_id)
        this.whatsappApp = (this.getWhatsAppApps || []).find(
          (app) => app.phone_number_id === this.getTicket.wa_phone_number_id,
        );
    },
    async loadWhatsAppMessageTemplates() {
      if (!this.getWhatsAppMessageTemplates) await this.getAllWhatsAppMessageTemplates();
    },
    async loadFiles() {
      if (!this.getFiles) await this.getAllFiles();
    },
    onOpenModalPreview() {
      const messageTemplate = this.getWhatsAppApprovedMessageTemplates.find(
        (template) => template.id === this.whatsappMessageTemplate,
      );

      this.messageTemplateSelected = { ...messageTemplate };
      this.dialogPreview = true;
    },
    onOpenModalImageViewer() {
      const messageMedia = this.getFiles.find((file) => file.id === this.whatsappMessageMedia);

      this.messageMediaSelected = messageMedia.url;
      this.dialogImageViewer = true;
    },
    onCheckWhatsappMessageTemplate() {
      this.whatsappMessageType = "text";
    },
    onChangeWhatsAppMessageType(type) {
      if (this.whatsappMessageType === type) return;

      this.useMessageTemplate = false;
      this.whatsappMessageMedia = null;
      this.whatsappMessageType = type;
    },
    async onComment() {
      try {
        this.loading = true;
        this.responseErrorMessage = null;

        if (!this.$refs.formActivity.validate())
          throw new Error("El formulario contiene datos inválidos, por favor verifique y vuelva a intentar");

        if (this.comment.type === this.$activityTypes.WHATSAPP) {
          let comment = this.comment;
          comment.wa_platform = this.getTicket.wa_platform || "cloudapi";
          comment.whatsapp_app_id = this.whatsappApp.id;
          if (this.useMessageTemplate) {
            comment.whatsapp_message_template_id = this.messageTemplateSelected.id;
            comment.whatsapp_message_template_body_params = (this.messageTemplateSelected.body_params || []).map(
              (param) => ({
                name: param.name,
                value: param.value,
              }),
            );
          }

          if (["image", "video", "document"].includes(this.whatsappMessageType)) {
            comment.whatsapp_message_file_type = this.whatsappMessageType;
            comment.whatsapp_message_file_id = this.whatsappMessageMedia;
          }

          if (this.whatsappMessageType === "upload") {
            comment.whatsapp_message_file_type = this.fileType.id;
            comment.whatsapp_message_file_name = this.fileContent.name;

            await this.addTicketCommentMedia({
              id: this.ticketId,
              comment: comment,
              file: this.fileContent,
            });
          } else {
            await this.addTicketComment({
              id: this.ticketId,
              comment: comment,
            });
          }

          this.comment.text = "";
          this.comment.whatsapp_message_template_id = "";
          this.comment.whatsapp_message_file_type = null;
          this.comment.whatsapp_message_file_id = null;
          this.useMessageTemplate = false;
          this.whatsappMessageTemplate = "";
          this.whatsappMessageType = "text";
          this.whatsappMessageMedia = null;
        } else {
          await this.addActivity({ ticket_id: this.ticketId, comment: this.comment });

          this.comment = { type: this.$activityTypes.COMMENT_BY_AGENT };
        }
        this.resetComment();
      } catch (error) {
        this.responseErrorMessage = error.message || "Ocurrió un problema al comentar la oportunidad";
      } finally {
        this.loading = false;
      }
    },
    resetComment() {
      this.$refs.formActivity.resetValidation();
      this.responseErrorMessage = null;
    },
    onNewEventClose(val) {
      this.dialogNewEvent = val;
      if (!val) this.comment.type = this.$activityTypes.COMMENT_BY_AGENT;
    },
    async markAsRead() {
      try {
        this.loadingMarkAsRead = true;

        await this.setTicketReadWaResponse({
          ticket_id: this.getTicket.id,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMarkAsRead = false;
      }
    },
    async onHandleWhatsappBotStatus() {
      try {
        this.loadingHandleWhatsappBotStatus = true;

        await this.setTicketBotStatus({
          id: this.getTicket.id,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingHandleWhatsappBotStatus = false;
      }
    },
  },
};
</script>

<style>
.speed-dial-custom {
  top: 0 !important;
  right: 0 !important;
}
</style>
